import styles from './Logo.css'

import logo from './images/logo.png'

export type TLogo = 'mfp' | 'mre' | 'bga'

export default function Logo (): HTMLElement {
  return (
    <div className="mt-logo">
      <img className={ styles.logo } alt="logo" src={ logo } />
    </div>
  )
}
